"use strict"

angular
	.module( "ATMGurus" )
	.controller("AccountController", AccountController);

AccountController.$inject = ["User",  "FilterService", "$scope", "$stateParams", "$location", "MyAccountService", "$q", "ApiQuery", "AddressBook", "dataProvider", "Auth"]

function AccountController(User, FilterService, $scope, $stateParams, $location, MyAccountService, $q, ApiQuery, AddressBook, dataProvider, Auth) {

	this.loading = false;
	this.pageName = $stateParams.page;
	this.queryString = dataProvider.queryString || '';
	this.queryStringObj = dataProvider.queryStringObj || '';

	// parameters for inventory usage aging modal
	this.currentAgingItem = undefined
	this.agingFilters = {
		page: 1,
		take: 10
	}

	var fieldsMap = {
		'saved-carts': [
			{ label: 'Cart Name', param: 'cart_id', sortable: true, html: '<a ui-sref="myaccount.subpage.details({ item: {{ value }} })">{{ value }}</a>'},
			{ label: 'Created', param: 'creation_date', sortable: true },
			{ label: 'Updated', param: 'last_update_date', sortable: true },
			{ label: 'Status', param: 'cart_status', sortable: true },
			{ label: 'Saved By', param: 'user_id', sortable: true },
		],
		orders: [
			{label: 'Order #', param: 'order_number', sortable: true, html: '<a ui-sref="myaccount.subpage.details({ item: {{ value }} })">{{ value }}</a>'},
			{label: 'Order Type', param: 'order_type', sortable: true },
			{label: 'Created', param: 'order_created', sortable: true },
			{label: 'Ship To Address', param: 'ship_to_address', sortable: true, html: '<span ng-bind-html="value | lb2br | unsafe"></span>' },
			{label: 'Shipped', param: 'ship_date', sortable: true },
			{label: 'Status', param: 'order_status', sortable: true },
			{label: 'User', param: 'user_id', sortable: true },
			// { label: 'Track', param: 'order_number', html: '<a href="#" ng-click="AccountCtrl.track(value)">Track</a>', sortable: false },
			{label: 'Track', param: 'tracking_url', html: '<span ng-if="value"><a href="{{ value }}" target="_blank">Track</a></span><span ng-if="!value">--</span>', sortable: false },
		],
		invoices: [
			{label: 'Date', param: 'invoice_date', sortable: true },
			{label: 'Invoice #', param: 'invoice_number', sortable: true },
			{label: 'Order #', param: 'order_number', sortable: true, html: '<a href="my-account/orders/{{value}}">{{ value }}</a>'},
			{label: 'Order Date', param: 'order_date', sortable: true },
			{label: 'PO Number', param: 'po_number', sortable: true },
			{label: 'Download', param: 'invoice_number', html: `<a href="/invoices/{{value}}.pdf${this.queryString}" target="_blank">Download</a>`, sortable: false }
		],
		'inventory-usage': [
			{label: 'Item #', param: 'item_number', sortable: true, html: '<a ng-click="AccountCtrl.fireModal(value)">{{ value }}</a>' },
			{label: 'Description', param: 'description', sortable: true },
			{label: '30 Days', param: 'shipped_in_last_30_days', sortable: true },
			{label: '90 Days', param: 'shipped_in_last_90_days', sortable: true },
			{label: '180 Days', param: 'shipped_in_last_180_days', sortable: true },
			{label: '365 Days', param: 'shipped_in_last_365_days', sortable: true }
		]
	}

	var repairsHeaders = {
		'Not Received': [
			{label: 'RMA #', param: 'order_number', sortable: true}, //html: '<a ui-sref="myaccount.subpage.details({ item: {{ value}} })">{{ value }}</a>'},//'<a ui-sref="myaccount.subpage.details({ \'page\': \'orders\', \'item\':{{ value }} })">{{ value }}</a>'},
			{label: 'CWI #', param: 'cwi_order_number', sortable: true},
			{label: 'Item #', param: 'item_number', sortable: true},
			{label: 'Description', param: 'description', sortable: true},
			{label: 'Quantity', param: 'quantity', sortable: false},
			{label: 'Days Waiting For Part', param: 'days_waiting_for_part', sortable: false},
			// {label: 'Days In House', param: 'days_in_house', sortable: false}
		],

		'Awaiting Shipment': [
			{label: 'RMA #', param: 'order_number', sortable: true}, //html: '<a ui-sref="myaccount.subpage.details({ item: {{ value }} })">{{ value }}</a>'},//'<a ui-sref="myaccount.subpage.details({ \'page\': \'orders\', \'item\':{{ value }} })">{{ value }}</a>'},
			{label: 'CWI #', param: 'cwi_order_number', sortable: true},
			{label: 'Item #', param: 'item_number', sortable: true},
			{label: 'Description', param: 'description', sortable: true},
			{label: 'Quantity', param: 'quantity', sortable: false},
			{label: 'Days In House', param: 'days_in_house', sortable: false}
		],

		'Awaiting Repair': [
			{ label: 'RMA #', param: 'order_number', sortable: true}, //html: '<a ui-sref="myaccount.subpage.details({ item: {{ value }} })">{{ value }}</a>'},//'<a ui-sref="myaccount.subpage.details({ \'page\': \'orders\', \'item\':{{ value }} })">{{ value }}</a>'},
			{ label: 'CWI #', param: 'cwi_order_number', sortable: true},
			{ label: 'Item #', param: 'item_number', sortable: true},
			{ label: 'Description', param: 'description', sortable: true},
			{ label: 'Quantity', param: 'quantity', sortable: false},
			{ label: 'Days In House', param: 'days_in_house', sortable: false}
		],

		'Recently Shipped': [
			{ label: 'RMA #', param: 'order_number', sortable: true}, //html: '<a ui-sref="myaccount.subpage.details({ item: {{ value }} })">{{ value }}</a>'},//'<a ui-sref="myaccount.subpage.details({ \'page\': \'orders\', \'item\':{{ value }} })">{{ value }}</a>'},
			{ label: 'CWI #', param: 'cwi_order_number', sortable: true},
			{ label: 'Item #', param: 'ordered_item', sortable: true},
			{ label: 'Description', param: 'description', sortable: true },
			{ label: 'Ship To Address', param: 'ship_to_address', sortable: true, html: '<span ng-bind-html="value | lb2br | unsafe"></span>' },
			{ label: 'Shipping Method', param: 'ship_method', sortable: false },
			{ label: 'Ship Date', param: 'ship_date', sortable: true},
			{ label: 'Carrier', param: 'carrier', sortable: false },
			// { label: 'Track', param: 'order_number', html: '<a href="#" ng-click="track({{value}})" target="_blank">Track</a>', sortable: false },
			{ label: 'Track', param: 'tracking_url', html: '<span ng-if="value"><a href="{{ value }}" target="_blank">Track</a></span><span ng-if="!value">--</span>', sortable: false }
		],
	};

	this.data = {};
	this.Filters = FilterService;
	this.contacts = []
	this.data = dataProvider.content;
	this.pagination = dataProvider.pagination;
	this.header = fieldsMap[this.pageName];
	this.status = {loading: false}
	this.timeframe = [365]

	this.toggleLoading = function( state ) {
		this.loading = state
		this.status.loading = state
	}

	$scope.MyAccountRootCtrl.currentPage = this.pageName

	/*
	*	Set correct filter for the page
	*/
	if ( typeof FilterService.filters[$stateParams.page] !== 'undefined' ) {
		this.filters = FilterService.filters[$stateParams.page];
	} else {
		this.filters = FilterService.get('myAccount');
	}

	// clone sortKey and sortOrder locally
	// because it simplifies tpl logic
	this.orderKey = Object.keys(this.filters.orderBy)[0];
	this.sortOrder = this.filters.orderBy[this.orderKey]

	this.changeOrderKey = function(key) {
		// did sorting column change
		if ( key !== this.orderKey ) {
			this.filters.orderBy = {}
			this.filters.orderBy[key] = this.sortOrder;
			this.orderKey = key;
		} else { // or do we wanna switch ordering?
			this.sortOrder = this.filters.orderBy[ this.orderKey ] = this.sortOrder === 'ASC' ? 'DESC' : 'ASC';
		}
		this.refresh();
	}

	this.isLoading = function() {
		return this.loading;
	}

	/**
	*	ADDRESS BOOK
	*/
	this.selectAddress = function( address ) {

		this.selected = address;
		this.toggleLoading(true);

		AddressBook.getShippingContacts(address.related_account_number)
			.then(response => {
				this.toggleLoading(false);
				if (response) {
					this.contacts = AddressBook.shippingContacts;
					$('#contacts-tab').click();
				}
			}, function(reason) {
				this.toggleLoading();
			} )
	}

	this.turnPage = function( target, incr ) {
		this.filters.page = parseInt( this.filters.page ) + incr ;
	}

	$scope.$watch("AccountCtrl.filters.page", (nv, ov) => {
		if ( nv !== ov ) {
			this.refresh()
		}
	})

	this.addDropShip = function() {
		$scope.$emit("modal.open", {title: 'Add new address', template: 'add_drop_ship'})
	}

	this.addContact = function() {
		$scope.$emit("modal.open", {title: 'Add contact', template: 'add_contact'})
	}

	// turn aging modal page
	$scope.$on('turn-aging', (e, amt) => {
		let next = this.pagination.current_page + amt
		if (next === 0) {
			next = 1
		}
		if (next > 0 && next <= this.pagination.last_page) {
			this.agingFilters.page += amt
			this.fireModal(this.currentAgingItem)
		} else {
			this.fireModal(this.currentAgingItem)
		}
	})

	/**
	*	fireModal
	*	Inventory Usage
	*/
	this.fireModal = function(item_number) {
		if (this.currentAgingItem !== item_number) {
			this.agingFilters.page = 1
		}
		this.currentAgingItem = item_number
		this.loading = true
		MyAccountService.agingReport(item_number, this.agingFilters)
			.then(response => {
				this.loading = false;
				$scope.$emit("modal.open", {
					title: 'Aging for Item #' + item_number,
					template: 'order_aging',
					data: {
						title: 'Aging for Item #' + item_number, // title for content area
						content: response.content,
						pagination: response.pagination
					}
				})
			})
	}

	this.getCsvUrl = function() {
		if (this.statusFilter === 'recently-shipped') {
			return 'account/repairs/recently-shipped-report-download/' + this.timeframe[0] + this.queryString
		} else if(this.statusFilter === 'inventory-usage') {
			return 'account/cwi/shipped-report-download' + this.queryString;
		} else {
			return 'account/repairs/report-download/' + this.queryString + '&' + this.statusFilter;
		}
	}


	this.track = function(order_number) {
		this.loading = true
		MyAccountService.tracking(order_number, this.agingFilters)
			.then(response => {
				this.loading = false
				if (response.content.length === 1) {
					$scope.$emit("modal.close")
					window.open(response.content[0].tracking_url)
				} else if (response.content.length > 1) {
					$scope.$emit("modal.open", {
						title: 'Select Tracking Option',
						template: 'tracking_redirect',
						data: {
							title: 'Tracking options for order: ' + order_number,
							links: response.content
						}
					})
				} else {
					$scope.$emit("modal.open", {
						title: 'Error while getting Tracking Informations',
						template: 'error',
						data: {
							message: ['There was an error while fetching the tracking link.'],
						}
					})
				}
			})
			.catch(e => {
				this.loading = false
			})
	}

	/**
	*	Refresh / Update
	* additional logic to get the right refresh target
	*/
	this.refresh = function(csv) {

		this.contacts = undefined;
		this.loading = true;

		var cb = undefined;
		var params = undefined;
		var filters = this.filters;
		var endpoint = this.pageName;

		// is user looking at recently shipped
		if (this.statusFilter === 'recently-shipped') {
			filters = this.filters = FilterService.filters['recently-shipped'];
			params = this.timeframe;
			endpoint = 'recently-shipped';
			cb = function() {
				this.header = repairsHeaders['Recently Shipped'];
			}.bind(this)
		} else if (this.pageName === 'repairs') {
			// is user looking at a generic repairs subpage
			filters = this.filters = FilterService.filters['account-repairs'];
			params = [this.statusFilter];
			endpoint = 'repairs-category';
			cb = function() {
				this.header = repairsHeaders[this.statusFilter];
			}.bind(this)
		}

		MyAccountService.getItem(endpoint, true, params, filters, csv)
			.then(function(response) {
				this.loading = false;
				this.pagination = response.pagination;
				this.data = response.content;
				if (cb) {
					cb(response);
				}
			}.bind(this))
	}

	/**
	*	REPAIRS
	*/
	this.statusFilter = undefined;

	// takes notice of status changes (button press on UI)
	this.updateStatus = function(label) {
		if (this.statusFilter === label) return;
		this.statusFilter = label;
		// we are calling the endpoint and add the label as a query parameter (/label)
		MyAccountService.params = [label];
		FilterService.clear('account-repairs');
		return this.refresh(false);
	}

	// Repairs page first load
	// data is the status buttons list
	if (this.pageName === 'repairs') {
		this.statusFilter = this.data[0];
		this.header = repairsHeaders[this.statusFilter]
		this.statusFilters = this.data;
		return this.refresh(false)
	} else if (this.pageName === 'inventory-usage') {
		this.statusFilter = 'inventory-usage';
	}

	this.goBack = function() {
		$state.go('^');
	}

	// $scope.$on('$destroy', () => {
	// })

}



// WEBPACK FOOTER //
// ./src/app/controllers/AccountController.js